module.exports = __webpack_public_path__ + "img/free.1a1d5232.jpg";